export const googlePlacesDivId = "google_places_tab_results";
export const googlePlacesDivId = "google_places_tab_results";
